import {
  checkInhabitantsExportTask,
  loadInhabitantsExportFieldsList,
  startInhabitantsExport,
} from '../../../../api'
import { getApiRequestFilterParams } from '../../../../utils/filter'
import { TableExportModal } from '../../../Table'

export function useInhabitantsHandleExport({
  excludeIds,
  filterValues,
  selectAllPages,
  selectedIds,
  sub,
  unselectAllPages,
  onCloseModal,
  onSetModal,
}) {
  function handleOpenExportModal() {
    onSetModal(
      <TableExportModal
        checkTask={checkInhabitantsExportTask}
        loadFieldList={loadInhabitantsExportFieldsList}
        startExport={startInhabitantsExport}
        tableExportGetResponseLinkModalProps={{
          excludeIds,
          filterValues,
          getApiRequestFilterParams,
          selectAllPages,
          selectedIds,
          sub,
          unselectAllPages,
        }}
        onClose={onCloseModal}
      />
    )
  }

  return {
    handleOpenExportModal,
  }
}
